module.exports = __webpack_public_path__ + "static/business_strategy-882cfd2bdef6297af9db1b08c76829f2.jpg";